/**
 * Component responsible to handle emitter events in order to style valid/invalid elements.
 */
import $ from 'jquery'
import dayjs from 'dayjs'
import { CPF } from 'cpf_cnpj'

import emitter from 'garden/src/js/utils/emitter'
import Validation from 'garden/src/js/components/validation'

import formatDate from 'scripts/utils/format-date'
import { validateNumberByState } from 'scripts/react-components/utils/account/factoryAddressRules.js'

Validation.prototype.rules.fullName = (field) => /^([\wÀ-ú']+\s)+[\wÀ-ú']+$/.test(field.value.trim())

Validation.prototype.rules.birthdate = (field) => {
  const inputValue = formatDate(field.value)
  const inputDate = new Date(inputValue)
  const currentDate = new Date()

  if (isNaN(inputDate.valueOf())) {
    return false
  }

  return (currentDate - inputDate) > 0
}

Validation.prototype.rules.isMinAge = (field) => {
  const inputValue = field.value.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')
  const birthdate = dayjs(inputValue)
  const now = dayjs()
  return (now.diff(birthdate, 'year') >= 18)
}

Validation.prototype.rules.isCpf = (field) => {
  return CPF.isValid(field.value)
}

Validation.prototype.rules.password = (field) => {
  const regexWord = /([a-zA-Z])/g
  const regexNumber = /([0-9])/g
  const regexSequential = /012|123|234|345|456|567|678|789/g

  if (field.value.match(regexWord) && field.value.match(regexNumber) && !field.value.match(regexSequential)) {
    return true
  }

  return false
}

Validation.prototype.rules.addressNumber = (field) => {
  const stateFieldId = $(field).data('state-field-id')
  const stateField = document.getElementById(stateFieldId)

  const stateFieldValue = stateField && $(stateField).val()
  const numberFieldValue = $(field).val()

  const isNumberFieldRequired = $(field).prop('required')
  const isEmptyAndNotRequired = !isNumberFieldRequired && !numberFieldValue

  if (isEmptyAndNotRequired) return true

  return validateNumberByState(numberFieldValue, stateFieldValue)
}

Validation.prototype.rules.zipcodedata = (field) => {
  const zipcodeDataError = $(field).data('zipcode-data-error')

  return !zipcodeDataError
}

/**
 * Styles the parent (Usually a fieldset) with invalid class.
 */
emitter.on('validation:error', (input) => {
  const $input = (input instanceof $) ? input : $(input)

  $input
    .closest('[data-validation="field"]')
    .removeClass('valid')
    .addClass('invalid')

  const target = $input.data('validate-target')
  const message = $input.data('validate-warning')

  if (target && message) {
    $(target).html(message)
  }
})

/**
 * Styles the parent (Usually a fieldset) with valid class.
 */
emitter.on('validation:success', (field) => {
  $(field).closest('[data-validation="field"]').removeClass('invalid')
  $(field).closest('[data-validation="field"]').addClass('valid')
})

emitter.on('validation:pristine', (field) => {
  const $field = $(field).closest('[data-validation="field"]')

  $field.removeClass('valid invalid')
})

export default ($el) => $el.validation()
